
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Choreography",
      function () {
        return require("private-next-pages/Choreography.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Choreography"])
      });
    }
  